import { LoadingOutlined } from '@ant-design/icons'
import { Spin } from 'antd'
import styled from '@emotion/styled'
import CenterContainer from './CenterContainer'

const LoadingContainer = styled(CenterContainer)`
  & > div {
    h1 {
      font-weight: bold;
      margin-top: 2em;
    }
  }
`

const Loading = () => (
  <LoadingContainer>
    <div>
      <Spin
        indicator={
          <LoadingOutlined
            style={{ fontSize: 128, color: '#FF691D' }}
            spin={true}
          />
        }
      />
      <br />
      <h1>โปรดรอสักครู่</h1>
    </div>
  </LoadingContainer>
)

export default Loading
